import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import { serverStatusMapToClientStatus } from '../../model/helper';
import type { HistoryRecord } from '../../model/types';

export type GetHistoryDetailReq = {
  historyRecordUuid: string;
};

export type GetHistoryDetailRes = {
  accountName: string;
  campaignName: string;
  histories: HistoryRecord[];
  historyRecordUuid: string;
  point?: number;
};

export const getHistoryDetail = async (
  params: GetHistoryDetailReq,
): Promise<GetHistoryDetailRes> => {
  const { historyRecordUuid } = params;

  const { data: response } = await serviceApi.campaign.getParticipateInDetailPostCampaign(
    withServiceRequestDefaults({
      postViewingRecordUuid: historyRecordUuid,
    }),
  );

  return {
    accountName: response.data.snsId,
    campaignName: response.data.name,
    histories: response.data.histories.map(({ historyStatus, createdAt, failReason }) => ({
      createdAt: createdAt,
      status: serverStatusMapToClientStatus(historyStatus, failReason),
    })),
    historyRecordUuid: response.data.postViewingRecordUuid,
    point: response.data.point !== null ? response.data.point : undefined,
  };
};
